import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, Row, Col, Alert } from 'antd';
import usecustomStyles from '../../Common/customStyles';
import ParticleAuth from '../../Common/ParticleAuth';
import { useFormik } from 'formik';
import styled from 'styled-components';
import logo from '../../assets/images/main_logo.png';

// actions
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import withRouter from '../../Common/withRouter';
import NeedHelp from '../../Common/NeedHelp/NeedHelp';
import { Link, useNavigate } from 'react-router-dom';
import { requestOtp, verifyOtp } from '../../slices/auth/login/thunk';
import { Spin } from 'antd/lib';
import Log from '../../Services/Log';
import loginImage from '../../assets/images/login_form_img.png'
import loginImage2 from '../../assets/images/login_banner.png'
import { validationContent } from '../../constants/Validation';
import { PlaceholderContent } from '../../constants/Placeholder';
const customStyles = usecustomStyles();
let placeholderContent = PlaceholderContent?.LOGIN_PAGE;
const StyleWrapper = styled.div`
    background-color: ${({ theme }) => theme.token.authbgcolor};
`;

const Signin = (props) => {
    const navigate = useNavigate();
    // page title
    document.title = "Sign In";

    const dispatch = useDispatch();
    const [isPhoneNumberValid, setPhoneNumberValid] = useState(false);
    const [status , setStatus] = useState(false);
    const selectAccountAndLogin = (state) => {
        return {
            user: state.Account.user,
            error: state.Login.error,
            loading: state.Login.loading,
            errorMsg: state.Login.errorMsg,
        };
    };
    const { user, error, loading, errorMsg } = useSelector(selectAccountAndLogin);
    const [isLoading, setLoading] = useState(false);
    const [isOtpSent, setOtpSent] = useState(false);
    const current = useSelector(state => state.Login);
    const [numberAdded , setNumberAdded] = useState(false)
   
    // Access entire state
    // useEffect(()=>{
    //     let accessToken = localStorage.accessToken
    //     if(accessToken){
    //         navigate('/dashboard')
    //     }
    // },[])

    useEffect(()=>{
        let loginPageStatus = localStorage.getItem('loginPageActive');
        if(loginPageStatus === 'signUp'){
            statusHandle(false)
        }
        else {
            statusHandle(true)
        }
    },[])
    useEffect(() => {
        sessionStorage.setItem('currentPage',0);
        if (user) {
            navigate('/dashboard');
        }
        Log('current' , 'info' , current)
        if (current.user.otp) {
            sessionStorage.setItem('fromLoginPage', 'true');
            navigate('/multi-step-form')
        }
    }, [current.user]);

    // Validation
    const validation = useFormik({
        initialValues: {
            phoneNumber: '',
            otp: '',
            country_code: '91'
        },
        validationSchema: Yup.object({
            country_code: Yup.string()
            .required(validationContent?.LOGIN_PAGE?.countryCode),
            phoneNumber: Yup.string()
                .required(validationContent?.LOGIN_PAGE?.phone)
                .matches(/^\d{10}$/, validationContent?.LOGIN_PAGE?.phoneNo), // Validate exactly 10 digits
            otp: Yup.string()
                .when('isOtpSent', {
                    is: true,
                    then: Yup.string().required(validationContent?.LOGIN_PAGE?.OTP).matches(/^\d{6}$/, validationContent?.LOGIN_PAGE?.OTPCount),
                }),
        }),
        onSubmit: async (values) => {
            setLoading(true);
            if (!isOtpSent) {
                // Dispatch requestOtp action
                dispatch(requestOtp(values.phoneNumber));
                // if (response.meta.requestStatus === 'fulfilled') {
                //     setOtpSent(true);
                // }
            } else {
                // Dispatch verifyOtp action
                const response = await dispatch(verifyOtp(values.phoneNumber, values.otp));
                
                if (response.meta.requestStatus === 'fulfilled') {
                    navigate('/dashboard');
                }
            }
            setLoading(false);
        }
    });
    useEffect(() => {
    if (validation.values.phoneNumber.match(/^\d{10}$/)) {
        setPhoneNumberValid(true);
    } else {
        setPhoneNumberValid(false);
    }
}, [validation.values.phoneNumber]);

    const statusHandle = ((data)=>{
        setStatus(data)
    })
    useEffect(()=>{
        if(status){
            localStorage.setItem('loginPageActive', 'signIn');
        }
        else{
            localStorage.setItem('loginPageActive', 'signUp');
        }
    },[status])
    return (
        <React.Fragment>
            <figure className="bg_wrapper">
            </figure>
            <StyleWrapper className={`${status ? 'sign_up_page' : 'sign_in_page'} auth-page-wrapper login`}>
                <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
                    <Col xs={24} lg={14} className='authentication_parent'>
                        <Card style={{ padding: "0" }} className='parent_radius login'>
                        <div className='form_wrap'>
                <div className='left'>
                    {
                        !status ? (
                            <figure className='login_banner'>
                                <img src={loginImage2} alt=''/>
                            </figure>
                        ) : <ParticleAuth statusHandle={statusHandle} text={'Already have an account?'}  />
                    }
                </div>
        <div className='right'>
            <div style={{ border: "0px" }} className='login_wrap'>
                <span>
                    <img src={logo} alt="logo" className='main_logo' />
                </span>
                <div className="text-center" style={{ margin: "20px"  }}>
                    <h5 className='text_lg' style={{ color: customStyles.colorPrimary }}>{status ? 'Create a New Account' : "Welcome Back!"}</h5>
                    <div className='tittle_support_cnt'>
                    <p className="sm2">{ status && "Let's start with your mobile number."}</p>
                    </div>
                </div>
                <div style={{ width: "100%",  maxWidth: '450px', margin: "0 auto" }}>
                    {error && <Alert type="error" message={error} />}
                    <Form onFinish={validation.handleSubmit}>
                    <label htmlFor="phoneNumber" className="text_red d-block ">Mobile Number</label>
                    <div className='wrap'> <Form.Item
                    style={{ marginBottom: 0, textAlign: "center" }}
                    name="country_code"
                    initialValue="+91" // Sets default value
                    >
                    <Input
                        className={`${!status && "text_red"} disabled_country_code`}
                        name="country_code"
                        autoComplete="off" 
                        style={{
                        color: "#9E9E9E",
                        textAlign: "center",
                        boxShadow: "none",
                        outline: "none",
                        }}
                        type="text"
                        value={validation.values.country_code || "+91"} // Controls input value with form values, defaults to 91
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        maxLength={2}
                        onKeyDown={(e) => {
                        if (!(e.key === "Backspace" || e.key === "Delete" || /^\d$/.test(e.key))) {
                            e.preventDefault();
                        }
                        }}
                    />
                    </Form.Item>
                        <Form.Item style={{ marginBottom: 0, textAlign: "center" }}
                            className='mobile_number_field'
                            name="phoneNumber"
                            validateStatus={validation.touched.phoneNumber && validation.errors.phoneNumber ? "error" : ""}
                            help={validation.touched.phoneNumber && validation.errors.phoneNumber}
                        >
                            <Input
                            className={`${!status && 'text_red'}`}
                                name="phoneNumber"
                                style={{ color: "#9E9E9E", textAlign: "left", boxShadow: 'none', outline: 'none', }}
                                type="text"
                                autoComplete="off" 
                                value={validation.values.phoneNumber}
                                onChange={validation.handleChange}
                                placeholder={'Add your phone number here..'}
                                // placeholder={!status ? placeholderContent?.SignIn : placeholderContent?.SignUp}
                                onBlur={validation.handleBlur}
                                maxLength={10}
                                onKeyDown={(e) => {
                                    if (!(e.key === 'Backspace' || e.key === 'Delete' || /^\d$/.test(e.key))) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Form.Item></div>
                        {
                            loading && (
                                <div className="spinner sm inner">
                                    <Spin/>
                                </div>
                            )
                        }
                        <Form.Item>
                            <div className='text-center'>
                                <Button htmlType="submit" type='primary'
                                disabled={!isPhoneNumberValid}
                                    style={{ width: "50%" }} loading={isLoading}>
                                Continue
                                </Button>
                            </div>
                        </Form.Item>
                    </Form>
                {
                    !status && (
                        <div style={{ marginTop: "50px" }} className="text-center login_navigate_content" >
                        <p  className="text_red" style={{fontSize: "16px"}}>New to Lumi Ads?
                            </p>
                            <div className='text-center'>
                            <Link onClick={()=>{
                                statusHandle(prev => !prev)
                            }}  className='solid_btn bg_lightred  text_red' style={{ marginRight: "5px", textDecoration: "underline", color: customStyles.colorSecondary, fontWeight: "600" , fontSize: '16px' }}>Sign Up
                            </Link>
                            </div>
                    </div>
                    )
                }
                </div>
            </div>
        </div>
    </div>

                        </Card>
                    </Col>
                    <NeedHelp />
                </Row>
            </StyleWrapper>
        </React.Fragment>
    );
}


export default withRouter(Signin);
